import React from 'react';
import EyebrowPill from './EyebrowPill';

export default function InnovationCard({
  eyebrow = 'Καινοτομία · Πρώτο στην Ελλάδα',
  title,
  titleEm,
  description,
  ctaText = 'Ανακαλύψτε την Καινοτομία',
  ctaHref = '#',
  coreSymbol = 'AI',
  className = '',
}) {
  return (
    <div className={`
      relative max-w-container-narrow mx-auto rounded-card-xl 
      bg-warm-black
      text-cream p-[60px_30px] md:p-[90px_70px] overflow-hidden
      ${className}
    `}>
      {/* Floating glow — static, no animation to avoid continuous GPU layer */}
      <div 
        className="absolute -top-[150px] -right-[150px] w-[500px] h-[500px] rounded-full pointer-events-none opacity-30"
        style={{ background: 'radial-gradient(circle, rgba(201,162,39,0.4), transparent 60%)' }}
      />
      
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-10 lg:gap-[60px] items-center">
        <div>
          <EyebrowPill variant="cream-on-dark" className="mb-[22px]">
            {eyebrow}
          </EyebrowPill>
          
          <h2 className="font-serif text-display-s text-cream mb-7 font-medium leading-[1] tracking-[-1.5px]">
            {title}
            {titleEm && (
              <>
                <br />
                <em className="italic text-gold-light">{titleEm}</em>
              </>
            )}
          </h2>
          
          <p className="text-[18px] leading-[1.7] opacity-90 mb-[38px] max-w-[540px]">
            {description}
          </p>
          
          <a 
            href={ctaHref}
            className="inline-flex items-center gap-2.5 bg-gold-bg text-warm-black px-9 py-[18px] rounded-pill font-semibold text-body-s transition-all duration-300 hover:bg-gold-light hover:-translate-y-0.5"
          >
            {ctaText} <span>→</span>
          </a>
        </div>
        
        <div className="aspect-square relative flex items-center justify-center">
          {/* Glow background */}
          <div 
            className="absolute inset-[10%] rounded-full pointer-events-none"
            style={{ background: 'radial-gradient(circle, rgba(201,162,39,0.2), transparent 70%)' }}
          />
          {/* Outer dashed ring */}
          <div 
            className="absolute inset-[5%] rounded-full border border-dashed pointer-events-none border-gold-light/30"
          />
          {/* Inner solid ring */}
          <div 
            className="absolute inset-[25%] rounded-full border pointer-events-none border-gold-light/20"
          />
          {/* Core */}
          <div className="font-serif italic text-[80px] md:text-[100px] text-gold-light relative z-10">
            {coreSymbol}
          </div>
        </div>
      </div>
    </div>
  );
}